import { z } from 'zod'
import { MESSAGES } from '../utils/messages'

// Formato general de NIT guatemalteco: dígitos + dígito verificador opcional (0-9 o K).
const NIT_REGEX = /^[0-9]+(-?[0-9kK])?$/

/**
 * Valida un NIT guatemalteco: formato + DÍGITO VERIFICADOR (módulo 11). Portado de
 * la fuente única de la app (apps/web-real-estate/src/shared/lib/utils.ts `nitValidation`)
 * para que el portal valide el NIT igual que el resto del sistema, no sólo el formato.
 */
export function isValidNit(nit: string): boolean {
  if (!nit || !NIT_REGEX.test(nit)) return false

  const clean = nit.replace(/-/, '')
  const lastChar = clean.length - 1
  const number = clean.substring(0, lastChar)
  const expectedChecker = clean.substring(lastChar, lastChar + 1).toLowerCase()

  let factor = number.length + 1
  let total = 0
  for (let i = 0; i < number.length; i++) {
    total += parseInt(number.substring(i, i + 1), 10) * factor
    factor -= 1
  }

  const modulus = (11 - (total % 11)) % 11
  const computedChecker = modulus === 10 ? 'k' : modulus.toString()
  return expectedChecker === computedChecker
}

export const nitRequired = () =>
  z
    .string()
    .min(1, MESSAGES.REQUIRED)
    .refine((v) => isValidNit(v), MESSAGES.NIT_INVALID)

export const nitOptional = () =>
  z
    .string()
    .optional()
    .refine((v) => !v || isValidNit(v), MESSAGES.NIT_INVALID)
